var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplaint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.153c0-1.047.848-1.895 1.895-1.895h14.21c1.047 0 1.895.848 1.895 1.895v9.473a1.895 1.895 0 0 1-1.895 1.895H4.421c-.41 0-.809.133-1.137.379L.91 16.68A.568.568 0 0 1 0 16.226V3.153z",
    fill: "#D63065"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.527,
    cy: 11.682,
    r: 0.947,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.527 4.102v4.736",
    stroke: "#fff",
    strokeWidth: 1.895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaint);
export default __webpack_public_path__ + "static/media/complaint.c0ab1d9803665ea23b43ee53a86bcb1f.svg";
export { ForwardRef as ReactComponent };